<mat-card *ngIf="pos">
  <mat-card-header>
    <mat-card-title
      >{{ 'general.infoPanels.position.parameters' | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Prozess</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="info-panel-container">
        <div>Prozess</div>
        <div>{{ pos.PROCESS_NAME }}</div>
        <div>Größenklasse</div>
        <div>{{ pos.GROESSENKLASSE_NAME }}</div>
        <div>Verwendung</div>
        <div>{{ pos.VERWENDUNG_NAME }}</div>
        <div>Härte Verfahren</div>
        <div>{{ pos.HARDENING_NAME }}</div>
        <div>Datenmodell</div>
        <div>{{ pos.MAF_DATAMODEL_NAME }}</div>
        <div>Form Bearbeitung</div>
        <div>{{ pos.MAF_FORM_PROD_TYPE_NAME }}</div>
        <div>Spezial Bearbeitung</div>
        <div>{{ pos.MAF_SPECIAL_PROCESSING_NAME }}</div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Logistik</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="info-panel-container">
        <div>Lagerort</div>
        <div>{{ pos.LAGERORT_NAME }}</div>
        <div>Lagerfach</div>
        <div>{{ pos.LAGERFACH_NAME }}</div>
        <mat-checkbox disabled checked="{{ pos.IST_MONTAGEBEREIT }}"
          >Montagebereit
        </mat-checkbox>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Beschaffung</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="info-panel-container">
        <div>Beschaffungsart</div>
        <div>{{ pos.DWS_BESCHAFFUNGSART_NAME }}</div>
        <div>Bestelldatum</div>
        <div>{{ pos.DWS_BESTELLDATUM | date }}</div>
        <div>Lieferdatum</div>
        <div>{{ pos.DWS_LIEFERDATUM | date }}</div>
        <div>Liefertermin</div>
        <div>{{ pos.DWS_LIEFERTERMIN | date }}</div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Abmessungen Fertigteil</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="info-panel-container">
        <div>Fertigmaß</div>
        <div>{{ pos.FERTIGMASS }}</div>
        <div>Breite Fertig</div>
        <div>{{ pos.BREITE_GES }}</div>
        <div>Höhe Fertig</div>
        <div>{{ pos.HOEHE_GES }}</div>
        <div>Länge Fertig</div>
        <div>{{ pos.LAENGE_GES }}</div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Abmessungen Rohteil</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="info-panel-container">
        <div>Profil</div>
        <div>{{ pos.PROFIL }}</div>
        <div>Breite 1 Rohteil</div>
        <div>{{ pos.ROHMASS_BREITE1 }}</div>
        <div>Breite 2 Rohteil</div>
        <div>{{ pos.ROHMASS_BREITE2 }}</div>
        <div>Höhe Rohteil</div>
        <div>{{ pos.ROHMASS_HOEHE }}</div>
        <div>Länge Rohteil</div>
        <div>{{ pos.ROHMASS_LAENGE }}</div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Material</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="info-panel-container">
        <div>Werkstoff</div>
        <div>{{ pos.WERKSTOFF_NAME }}</div>
        <div>DINISO-Norm</div>
        <div>{{ pos.DIN_ISO_NORM }}</div>
        <div>Hersteller MaterialNr.</div>
        <div>{{ pos.HERSTELLER_MATERIALNR }}</div>
        <div>Hersteller Name</div>
        <div>{{ pos.HERSTELLERNAME }}</div>
        <div>Identnummer</div>
        <div>{{ pos.IDENTNUMMER }}</div>
        <div>Material</div>
        <div>{{ pos.MATERIALPSE_NAME }}</div>
      </div>
    </mat-expansion-panel>
  </mat-card-content>
</mat-card>
